export function isEmptyQuillFeedback(questionFeedback: { ops?: { insert: string }[] }) {
  return (
    questionFeedback?.ops &&
    (!questionFeedback?.ops?.length || (questionFeedback.ops.length === 1 && questionFeedback.ops[0].insert?.trim() === ''))
  );
}
